import * as actionType from "../actions/actionTypes"

const initialState: any = {}

export default function userDataReducer(state = initialState, action: any) {
  if (action.type === actionType.SET_USER_DATA) {
    return {
      ...state,
      ...action.value
    }
  }
  
  return state
}
